export default __webpack_public_path__ + "static/media/BEL2018_Coastal_Swatch_Appian_Titanium_0.eed7ee42.jpg";